import { useState } from 'react'
import { Box, Tab, Tabs } from '@mui/material'
import AvitoAutoloadWorkspace from '../components/avito/AvitoAutoloadWorkspace'
import AvitoAccountsSettings from '../components/settings/integrations/AvitoAccountsSettings'

function AvitoPage() {
	const [tab, setTab] = useState(0)

	return (
		<Box sx={{ width: '100%', p: { xs: 2, md: 3 } }}>
			<Tabs
				value={tab}
				onChange={(_, value) => setTab(value)}
				aria-label="Разделы Авито"
				sx={{ mb: 3 }}>
				<Tab label="Автозагрузка" />
				<Tab label="Аккаунты" />
			</Tabs>
			{tab === 0 ? (
				<AvitoAutoloadWorkspace onManageAccounts={() => setTab(1)} />
			) : (
				<AvitoAccountsSettings />
			)}
		</Box>
	)
}

export default AvitoPage
